// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"d3e86147","204":"07952695","321":"bd30ca18","324":"5258ee82","339":"2c0ea927","342":"59fe88a1","584":"804139cb","651":"21770515","670":"9c3ef99b","735":"4f6c1ccc","832":"2798656c","931":"44ebf142","935":"50d872a8","971":"3bb0e2d2"}[chunkId] + ".chunk.css";
};